import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef, EventEmitter, Output
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { NgxFileDropEntry } from "ngx-file-drop";
import { EMPTY, from, merge, Observable, Subject, Subscription } from "rxjs";
import { ChatService } from "../../chat.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@aihub/core/authorization";
import {
  catchError,
  debounceTime,
  finalize,
  map,
  switchMap,
  take,
  takeUntil,
} from "rxjs/operators";
import * as PROMPTS from "./prompt.constant";
import { Chat, Message, MessageData } from "../../types";

@Component({
  selector: 'app-kbin',
  templateUrl: './kbin.component.html',
  styleUrls: ['./kbin.component.css']
})
export class KbinComponent implements OnInit {
  @Input() subscription_id: string = "";
  @Output() displayResponse = new EventEmitter<any>();

  public formJson;
  form: FormGroup;
  public uploadIcon = false;
  showForm = false;


  constructor(
    private formBuilder: FormBuilder,
    private chatService: ChatService,

  ) {}

  ngOnInit() {
    this.getFormJson();
  }

  getFormJson() {
    this.chatService.getFormJson().subscribe((res) => {
      this.formJson = res.data;
      this.initForm();
    });
  }

  initForm() {
    this.form = this.formBuilder.group(
      this.formJson.reduce(
        (acc, control) => ({ ...acc, [control.name]: "" }),
        {}
      )
    );
    this.showForm = true;
  }

  onSubmit() {
    // as an example for hackathon
    console.log(this.form.value);
    const promptInput = PROMPTS.prefix + this.form.value.additionalInformation + PROMPTS.suffix;
    this.displayResponse.emit(promptInput);
  }


  // Form elements

  // File on drop
  public drop(files: NgxFileDropEntry[]): void {
    this.uploadIcon = true;

    files.forEach((file) => {
      if (file.fileEntry.isFile) {
        const dropped = file.fileEntry as FileSystemFileEntry;
        dropped.file(async (droppedFile: File) => {
          from(this.convertImageToBase64(droppedFile))
            .pipe(
              //   switchMap((iconUrl) =>
              //     // this.assetRepository.setData("marketplace_data.asset.icon_url",iconUrl)
              //     console.log(iconUrl)
              //   ),
              finalize(() => (this.uploadIcon = false)),
              catchError((error: Error) => {
                // this.alertService.error(error);

                return EMPTY;
              }),
              take(1)
            )
            .subscribe();
        });
      }
    });
  }

  /**
   * convert an image to base64
   *
   */
  public convertImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      if (file.size / (1024 * 512) >= 1) {
        reject(`Filesize is too big, maximum allowed file size is 512kb.`);
      }

      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(file);
    });
  }


}
